if (!customElements.get("product-form")) {
  // Global flag to prevent multiple simultaneous submissions
  window.productFormSubmitting = false;
  
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.isSubmitting = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        /*         console.log("Drawer Event Started"); */
        /*         console.log(this.submitButton); */
        
        // Prevent double submission - check both local and global flags
        if (this.isSubmitting || window.productFormSubmitting) {
          evt.stopImmediatePropagation();
          return;
        }
        
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Set global flag to prevent other forms from submitting
        window.productFormSubmitting = true;
        this.isSubmitting = true;
        
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        /*     this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        ); */

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            // Coloca el código aquí para desactivar el botón en el cart-drawer si es necesario
            var trueFound = false;
            var falseFound = false;
            var cartItems = document.querySelectorAll(".cart-item");

            cartItems.forEach(function (item) {
              var teamStoreValue = item.getAttribute("data-team-store-drawer");
              if (teamStoreValue === "true") {
                trueFound = true;
              } else if (teamStoreValue === "false") {
                falseFound = true;
              }
            });

            if (trueFound && falseFound) {
              var button = document.getElementById("CartDrawer-Checkout");
              button.setAttribute("disabled", "disabled");
              var popup = document.getElementById("drawer-popup");
              popup.style.display = "block";
            }
          })
          .catch((e) => {
            console.error(e);
            this.isSubmitting = false;
            window.productFormSubmitting = false;
          })
          .finally(() => {
            this.isSubmitting = false;
            window.productFormSubmitting = false;
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");

            const mobilePurchaseRoot = this.querySelector(".rocket-mobile-purchase");
            if (
              mobilePurchaseRoot?.classList.contains(
                "rocket-mobile-purchase--drawer-open"
              )
            ) {
              mobilePurchaseRoot.classList.remove(
                "rocket-mobile-purchase--drawer-open"
              );
              mobilePurchaseRoot
                .querySelector(".rocket-mobile-size-drawer")
                ?.setAttribute("aria-hidden", "true");
              document.body.classList.remove("rocket-mobile-drawer-open");
              const opener = mobilePurchaseRoot.querySelector(
                ".rocket-mobile-purchase__opener"
              );
              if (opener) opener.setAttribute("aria-expanded", "false");
            }

            // Call the function to get the most expensive product's id
            let mostExpensiveId = getMostExpensiveProductId();

            if (typeof mostExpensiveId == "string") {
              getProductRelated("gid://shopify/Product/" + mostExpensiveId);
            }

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
